import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { 
  CheckCircle, 
  Home, 
  Bed, 
  Eye, 
  Car, 
  Building, 
  Sparkles,
  MapPin 
} from 'lucide-react';

const ProjectSection = () => {
  const openVirtualTour = () => {
    window.open('https://vr.shinewonder.com/pano/page/publik/pklimit?inf=@DBFFDBMMFBBEFDA@', '_blank');
  };

  const features = [
    {
      icon: <Home className="h-6 w-6 text-amber-600" />,
      text: "Superficie 250 m²"
    },
    {
      icon: <Bed className="h-6 w-6 text-amber-600" />,
      text: "4 chambres + salon spacieux"
    },
    {
      icon: <Eye className="h-6 w-6 text-amber-600" />,
      text: "Balcons vue mer"
    },
    {
      icon: <Car className="h-6 w-6 text-amber-600" />,
      text: "Parking sous-sol"
    },
    {
      icon: <Building className="h-6 w-6 text-amber-600" />,
      text: "Ascenseur dernière génération"
    },
    {
      icon: <Sparkles className="h-6 w-6 text-amber-600" />,
      text: "Finitions haut standing"
    }
  ];

  return (
    <section id="project" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <Badge className="mb-6 bg-blue-100 text-blue-800 border-blue-200">
              <Building className="h-4 w-4 mr-2" />
              Présentation du Projet
            </Badge>

            <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-8 leading-tight">
              Résidence NATOMA
              <br />
              <span className="text-amber-600">Haut Standing</span>
            </h2>

            <div className="prose prose-lg text-slate-600 mb-6">
              <p>
                Un immeuble R+8 d'exception situé aux Almadies, le quartier le plus 
                prestigieux de Dakar. Profitez d'une localisation unique en front de mer 
                avec tous les services de proximité.
              </p>
            </div>

            {/* Location Link */}
            <div className="mb-10">
              <a
                href="https://maps.app.goo.gl/8kZBFpFN3fg52wSE8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-3 rounded-lg border border-blue-200 hover:bg-blue-100 hover:border-blue-300 transition-all duration-300 font-medium"
              >
                <MapPin className="h-5 w-5" />
                📍 Voir la localisation exacte sur Google Maps
              </a>
            </div>

            {/* Features Checklist */}
            <div className="space-y-4 mb-10">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center space-x-4 group">
                  <div className="w-12 h-12 bg-slate-50 rounded-full flex items-center justify-center group-hover:bg-amber-50 transition-colors duration-300">
                    {feature.icon}
                  </div>
                  <span className="text-lg text-slate-700 font-medium">{feature.text}</span>
                  <CheckCircle className="h-5 w-5 text-emerald-500 ml-auto" />
                </div>
              ))}
            </div>

            {/* CTA */}
            <Button 
              onClick={openVirtualTour}
              size="lg"
              variant="outline"
              className="border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white px-8 py-4 text-lg font-semibold"
            >
              <Eye className="h-5 w-5 mr-2" />
              Découvrez votre futur appartement
            </Button>
          </div>

          {/* Visual */}
          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-amber-600 rounded-2xl transform rotate-3"></div>
              <img 
                src="https://customer-assets.emergentagent.com/job_perfect-match-17/artifacts/z4eaard8_Cuisine%20%282%29.jpg"
                alt="Résidence NATOMA - Vue intérieure"
                className="relative w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-6 shadow-xl">
                <div className="text-center">
                  <div className="text-2xl font-bold text-slate-800">250m²</div>
                  <div className="text-sm text-slate-600">Surface</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;